// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"687":"90cfca6d","702":"45949594","708":"ca7b7a37","766":"bb3cf593"}[chunkId] + ".chunk.css";
};